import { useState, useCallback } from 'react';
import { ToastItem } from 'components/toast/ToastContainer';

export const useToast = () => {
  const [toasts, setToasts] = useState<ToastItem[]>([]);

  const addToast = useCallback((type: 'success' | 'error' | 'warning' | 'info', message: string, duration?: number) => {
    const id = `toast-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

    const defaultDurations = {
      success: 3000,
      error: 5000,
      warning: 4000,
      info: 3000,
    };

    const toastDuration = duration || defaultDurations[type];

    const newToast: ToastItem = {
      id,
      type,
      message,
      duration: toastDuration,
    };

    setToasts(prev => [...prev, newToast]);

    return id;
  }, []);

  const removeToast = useCallback((id: string) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  }, []);

  const success = useCallback(
    (message: string, duration?: number) => addToast('success', message, duration),
    [addToast]
  );

  const error = useCallback((message: string, duration?: number) => addToast('error', message, duration), [addToast]);

  const warning = useCallback(
    (message: string, duration?: number) => addToast('warning', message, duration),
    [addToast]
  );

  const info = useCallback((message: string, duration?: number) => addToast('info', message, duration), [addToast]);

  return {
    toasts,
    addToast,
    removeToast,
    success,
    error,
    warning,
    info,
  };
};
